import './Card.scss';

const Card = ({ data }) => {
  return (
    <div className='dk_slider_card'>
      <div className='slider_card_inner'>
        <div className='name_container'>
          <img
            src={data.image}
            style={{ borderRadius: '50%' }}
            width='41'
            height='41'
            alt=''
            loading='lazy'
          />
          <div className='name_inner'>
            <span>{data.name}</span>
            <img src="https://static.kickcash.in/kickcash/prime_offer/icon/146bc28a-0a27-4f61-bf7d-23880fe18d03.png" alt='stars' loading='lazy' />
          </div>
        </div>
        <div className='title'>Review</div>
        <div className='comment'>{data.comment}</div>
      </div>
    </div>
  );
};

export default Card;
